import { render, staticRenderFns } from "./DateRangeExt.vue?vue&type=template&id=0aaf165e&scoped=true&"
import script from "./DateRangeExt.vue?vue&type=script&lang=js&"
export * from "./DateRangeExt.vue?vue&type=script&lang=js&"
import style0 from "./DateRangeExt.vue?vue&type=style&index=0&id=0aaf165e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf165e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aaf165e')) {
      api.createRecord('0aaf165e', component.options)
    } else {
      api.reload('0aaf165e', component.options)
    }
    module.hot.accept("./DateRangeExt.vue?vue&type=template&id=0aaf165e&scoped=true&", function () {
      api.rerender('0aaf165e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25WzVhz75a9O0/JS/comp/DateRangeExt.vue"
export default component.exports